// Christmas No.1s are featured throughout December; ?xmas=1 previews it any time.
export const isFestive = () => {
  try {
    if (new URLSearchParams(window.location.search).get("xmas") === "1") return true;
  } catch { /* ignore */ }
  return new Date().getMonth() === 11;
};

export const XMAS_URL = "/trivia/play?source=pack&pack=christmas-number-ones&mode=mc&group=0&count=10";
